// assets/js/components/revenue-calculator/steps/results-page.js
var ui = require("../ui");
var data = require("../data");
var calc = require("../calc");
var intlData = require("../intl-data");

function ctaButtons(priLabel, priUrl, secLabel, secUrl) {
    return (
        '<div class="rc-calc__cta-row">' +
        '<a href="' + priUrl + '" target="_blank" rel="noopener noreferrer" class="btn btn--alt rc-calc__btn rc-calc__btn--primary">' + priLabel + "</a>" +
        '<a href="' + secUrl + '" target="_blank" rel="noopener noreferrer" class="btn btn--white rc-calc__btn rc-calc__btn--secondary">' + secLabel + "</a>" +
        "</div>"
    );
}

function render(state, locale) {
    var d = state.d, path = state.path;
    var sym = intlData.getCurrencySymbol(locale, d.currency);
    var r = calc.calcResults(d, path, sym);
    var money = function (val) { return intlData.formatMoney(locale, d.currency, val); };
    var recs = calc.buildRecs(d, r, path);
    var benchmarks = calc.getBenchmarks(d, r, path);

    var isExisting = d.bookingSystem === "SimplyBook.me";
    var isEnterprise = Number(d.locations) >= 5 && !isExisting;

    var ctaTrial = data.addUTM("https://simplybook.me/en/default/registration", "start_free_trial");
    var ctaOptimize = data.addUTM("https://simplybook.me/en/default/registration", "optimize_your_setup");
    var ctaEnterprise = data.addUTM("https://bigaccounts.simplybook.it/v2/#book/category/11/count/1/provider/any/", "book_a_call");
    var ctaHome = data.addUTM("https://simplybook.me/en/", "see_how_it_works");
    var ctaSellMore = data.addUTM("https://simplybook.me/en/sell-more", "explore_more_ways_to_grow");

    var priLabel, priUrl, secLabel, secUrl;
    if (isExisting) { priLabel = _t("Optimize your setup"); priUrl = ctaOptimize; secLabel = _t("Explore more ways to grow"); secUrl = ctaSellMore; }
    else if (isEnterprise) { priLabel = _t("Book a call"); priUrl = ctaEnterprise; secLabel = _t("See how SimplyBook.me works"); secUrl = ctaHome; }
    else { priLabel = _t("Start your free trial"); priUrl = ctaTrial; secLabel = _t("See how SimplyBook.me works"); secUrl = ctaHome; }

    var html = '<p class="rc-calc__eyebrow">' + (state.firstName ? _t("%name%'s report").replace("%name%", ui.esc(state.firstName)) : _t("Your report")) + "</p>";

    if (r.isWellOpt) {
        html += '<div class="rc-calc__result-block rc-calc__result-block--good">' +
            '<p class="rc-calc__result-eyebrow">' + _t("Estimated revenue at risk") + "</p>" +
            '<div class="rc-calc__result-figure">' + money(r.total) + '<span class="rc-calc__unit">' + _t("/mo") + "</span></div>" +
            '<p class="rc-calc__result-sub">' + _t("Your setup looks strong and well-optimised. Based on your answers, you are already using many best practices. Your reported losses are low. Keep it up.") + "</p>" +
            "</div>";
    } else {
        html += '<div class="rc-calc__result-block rc-calc__result-block--warning">' +
            '<p class="rc-calc__result-eyebrow">' + _t("Estimated revenue at risk") + "</p>" +
            '<div class="rc-calc__result-figure">' + money(r.total) + '<span class="rc-calc__unit">' + _t("/mo") + "</span></div>" +
            '<p class="rc-calc__result-sub">' + _t("Based on your answers, this is the estimated monthly revenue your business may be losing today.") + "</p>" +
            "</div>";

        if (r.hasToolsLosing) {
            html += '<div class="rc-calc__notice rc-calc__notice--warning">' +
                '<p class="rc-calc__notice-title">' + _t("Your business already has several tools in place") + "</p>" +
                '<p class="rc-calc__notice-body">' + _t("However, your answers still suggest measurable revenue leakage. The opportunity may be less about adding new tools and more about optimising how your current setup is configured and used.") + "</p>" +
                "</div>";
        }

        html += ui.sectionLabel(_t("Where that lost revenue may be coming from"));
        html += '<div class="rc-calc__answers-grid">' + buildAnswerRows(d, path, money).map(function (row) {
            return '<div class="rc-calc__answer-row"><span>' + row.l + ": </span><span class=\"rc-calc__answer-value\">" + ui.esc(row.v) + "</span></div>";
        }).join("") + "</div>";

        html += '<div class="rc-calc__loss-list">' + buildLossItems(r, d, money).map(function (item) {
            return '<div class="rc-calc__loss-item"><div class="rc-calc__loss-main"><div class="rc-calc__loss-title">' + item.title + '</div><div class="rc-calc__loss-sub">' + item.sub + "</div></div>" +
                '<div class="rc-calc__loss-value">' + money(item.val) + "</div></div>";
        }).join("") + "</div>";

        html += '<div class="rc-calc__result-block rc-calc__result-block--good">' +
            '<p class="rc-calc__result-eyebrow">' + _t("Potential recoverable revenue") + "</p>" +
            '<div class="rc-calc__result-figure">' + _t("Up to %amount%").replace("%amount%", money(r.totalRec)) + "</div>" +
            '<p class="rc-calc__result-sub">' + _t("Estimated growth potential based on the tools and processes not yet in use.") + "</p>" +
            (r.adminVal > 0 ? '<p class="rc-calc__result-sub">' + _t("+ Up to %amount% in additional capacity from time saved on admin").replace("%amount%", money(r.adminVal)) + "</p>" : "") +
            "</div>";
    }

    if (recs.length) {
        html += ui.sectionLabel(_t("A few things still worth exploring"));
        html += ui.card('<div class="rc-calc__recs-list">' + recs.map(function (rec) {
            return '<div class="rc-calc__rec-row">' + rec.html + "</div>";
        }).join("") + "</div>");
    }

    var manualIsGCal = d.bookingSystem === "Google Calendar / manual";
    var showManualMsg = (d.hasBookingSystem === "No" || manualIsGCal) && !data.getComp(d.bookingSystem);
    if (showManualMsg) {
        html += buildManualMsg(d, manualIsGCal, Number(d.locations) >= 5);
    }
    var compData = data.getComp(d.bookingSystem);
    if (compData) {
        html += buildCompBox(d.bookingSystem, compData);
    }

    if (benchmarks.length) {
        html += ui.sectionLabel(_t("How you compare"));
        html += ui.card(benchmarks.map(function (b, i) {
            return '<div class="rc-calc__benchmark-row"' + (i < benchmarks.length - 1 ? ' style="border-bottom:1px solid var(--rc-border)"' : "") + "><span>" + b + "</span></div>";
        }).join(""));
    }

    html += '<p class="rc-calc__disclaimer"><strong>' + _t("DISCLAIMER.") + "</strong> " +
        _t("These estimates are based on industry averages and your inputs. Actual results may vary significantly based on your specific business, market conditions, and operational factors. This is for informational purposes only and does not constitute financial or business advice. We recommend consulting with professionals before making business decisions.") +
        "</p>";

    html += '<div class="rc-calc__final-cta">' +
        '<h2 class="rc-calc__final-cta-title">' + (r.isWellOpt ? _t("Keep growing with SimplyBook.me") : _t("Ready to recover this revenue?")) + "</h2>" +
        '<p class="rc-calc__final-cta-sub">' + (r.isWellOpt ? _t("You've built a solid foundation. Explore what else SimplyBook.me can do for your business.") : _t("SimplyBook.me has all the tools to help you protect and grow your monthly revenue.")) + "</p>" +
        ctaButtons(priLabel, priUrl, secLabel, secUrl) +
        "</div>";

    return html;
}

function buildAnswerRows(d, path, money) {
    var rows = [
        { l: _t("Business"), v: (data.label(d.businessType) || "—") + ", " + (d.countryName || "—") },
        { l: _t("Staff / locations"), v: (d.staffCount || "—") + " " + _t("staff") + " · " + (d.locations || "—") + " " + (Number(d.locations) > 1 ? _t("locations") : _t("location")) },
        { l: _t("Booking system"), v: d.hasBookingSystem === "No" ? _t("None") : (data.label(d.bookingSystem) || "—") },
        { l: _t("Monthly bookings"), v: (d.bookingsMonth || "—") + " × " + (d.avgBookingValue ? money(d.avgBookingValue) : "—") },
        { l: _t("No-shows / month"), v: String(Number(d.noShowsMonth) || 0) },
        { l: _t("Empty hours / week"), v: (d.emptyHours || 0) + " " + _t("hrs") },
        { l: _t("Cancellations / month"), v: String(Number(d.cancelations) || 0) }
    ];
    if (path === "advanced") {
        rows.push({ l: _t("Review requests"), v: data.label(d.requestsReviews) || "—" });
        rows.push({ l: _t("Campaigns / month"), v: data.label(d.campaignsPerMonth) || "—" });
        rows.push({ l: _t("Currently promoting"), v: (d.promotes && d.promotes.length) ? d.promotes.map(data.label).join(", ") : _t("None selected") });
    }
    return rows;
}

// Replaces every %key% occurrence (String#replace only does the first one).
function fill(str, values) {
    return Object.keys(values).reduce(function (out, key) { return out.split("%" + key + "%").join(values[key]); }, str);
}

// The msgids keep their "%sym%%avg%" shape so existing translations still match; %sym% is
// dropped and the amount placeholders get fully formatted money, so the symbol lands
// where the locale puts it.
function buildLossItems(r, d, money) {
    var items = [];
    var avg = money(r.avg), hrly = money(r.hrly);
    if (r.nsLoss > 0) items.push({ title: _t("No-shows"), sub: fill(_t("%n% no-shows × %sym%%avg% · reduced %pct%% by active tools"), { sym: "", n: String(r.ns), avg: avg, pct: String(Math.round(r.nsMit * 100)) }), val: r.nsLoss });
    if (r.emLoss > 0) items.push({ title: _t("Empty appointment time"), sub: fill(_t("%hrs% hrs/wk × %sym%%hrly%/hr (%sym%%avg% booking ÷ %dur%h appt) × 4.33 weeks"), { sym: "", hrs: String(Number(d.emptyHours) || 0), hrly: hrly, avg: avg, dur: String(r.dur) }), val: r.emLoss });
    if (r.cancLoss > 0) items.push({ title: _t("Last-minute cancellations"), sub: fill(_t("%n% cancellations × %sym%%avg% · reduced %pct%% by active tools · 80% estimated as unrecovered"), { sym: "", n: String(Number(d.cancelations) || 0), avg: avg, pct: String(Math.round(r.cancMit * 100)) }), val: r.cancLoss });
    if (r.missedL > 0) items.push({ title: _t("Missed online booking opportunity"), sub: _t("Growth potential from limited booking channel coverage"), val: r.missedL });
    if (r.retL > 0) items.push({ title: _t("Underused retention tools"), sub: _t("Revenue gap from limited marketing and loyalty activity"), val: r.retL });
    return items;
}

function buildManualMsg(d, isGCal, isEnterprise) {
    var intro = isEnterprise ? _t("Managing bookings manually across multiple locations becomes complex, time-consuming, and difficult to scale.")
        : isGCal ? _t("Managing bookings through Google Calendar or manual processes may work at first, but it quickly becomes limiting as your business grows.")
        : _t("Running your bookings through calls, messages or a calendar might work at first, but it quickly becomes time-consuming and hard to scale.");
    var valueLine = isGCal ? _t("Start accepting bookings 24/7, even when you're offline, and create a more seamless experience for your clients.")
        : _t("Start accepting bookings 24/7, even when you're offline, and present a more professional experience that builds trust with new clients.");
    var points = [
        _t("Let clients book appointments themselves without back-and-forth messages"),
        _t("Reduce missed bookings with automatic reminders"),
        _t("Fill your schedule faster with online booking links and Google visibility"),
        _t("Keep everything in one place instead of juggling calls, messages and notes"),
        _t("Save hours every week on admin and focus on your actual work")
    ];
    var ctaUrl = isEnterprise
        ? data.addUTM("https://bigaccounts.simplybook.it/v2/#book/category/11/count/1/provider/any/", "book_call_no_system_enterprise")
        : data.addUTM("https://simplybook.me/en/default/registration", "start_free_trial_no_system");
    var ctaLabel = isEnterprise ? _t("Book a call") : _t("Start your free trial");

    return '<div class="rc-calc__manual-msg">' +
        '<h3 class="rc-calc__manual-title">' + _t("Still managing bookings manually?") + "</h3>" +
        '<p class="rc-calc__manual-intro">' + intro + "</p>" +
        '<div class="rc-calc__manual-points">' + points.map(function (p, i) {
            return '<div class="rc-calc__manual-point"><svg class="rc-calc__check-icon" width="20" height="20" viewBox="0 0 20 20" aria-hidden="true"><circle cx="10" cy="10" r="10" fill="#00d38b"/><path d="M5.5 10.5L8.5 13.5L14.5 7.5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none"/></svg><span>' + p + "</span></div>";
        }).join("") + "</div>" +
        (isEnterprise ? '<p class="rc-calc__manual-note">' + _t("For multi-location businesses, having a centralized booking system is essential to maintain control, visibility, and growth.") + "</p>" : "") +
        '<p class="rc-calc__manual-value mb-3">' + valueLine + "</p>" +
        '<a href="' + ctaUrl + '" target="_blank" rel="noopener noreferrer" class="btn btn--alt rc-calc__btn rc-calc__btn--primary">' + ctaLabel + "</a>" +
        "</div>";
}

function buildCompBox(bookingSystem, compData) {
    var switchUrl = data.addUTM("https://bigaccounts.simplybook.it/v2/?widget-type=button&theme=creative&timeline=modern&datepicker=inline_datepicker&class=enterprise-widget%20enterprise-widget__white#book/category/21/count/1/provider/any/", "switch_to_simplybook");
    return '<div class="rc-calc__comp-box">' +
        '<p class="rc-calc__comp-title">' + _t("Considering a switch from %system%?").replace("%system%", ui.esc(data.label(bookingSystem))) + "</p>" +
        '<p class="rc-calc__comp-headline">' + compData.h + "</p>" +
        '<p class="rc-calc__comp-body">' + compData.b + "</p>" +
        '<a href="' + switchUrl + '" target="_blank" rel="noopener noreferrer" class="btn btn--alt rc-calc__btn rc-calc__btn--primary">' + _t("Switch to SimplyBook.me") + "</a>" +
        "</div>";
}

module.exports = { render: render };
